package xim.poc.game.configuration.v0.tactics

import xim.poc.audio.SystemSound
import xim.poc.game.ActorState
import xim.poc.game.GameEngine.targetFlags
import xim.poc.game.QueryMenuOption
import xim.poc.game.QueryMenuResponse
import xim.poc.game.UiStateHelper
import xim.poc.game.configuration.constants.SkillId
import xim.poc.ui.ChatLog
import xim.poc.ui.ChatLogColor
import xim.poc.ui.ShiftJis
import xim.resource.AoeType
import xim.resource.TargetFlag

object TacticsNoopContext: TacticsUiContext {

    override fun onActivated() {
    }

    override fun handleEnter() {
    }

    override fun handleExit() {
    }

    override fun applyPanelHighlights() {
    }

}

class TacticsTowerContext(val ui: TacticsUi): TacticsUiContext {

    companion object {
        private var described = false
    }

    init {
        describeSelf()
    }

    override fun onActivated() {
        val setupOptions = listOf(
            QueryMenuOption("Summon.", 0),
            QueryMenuOption("Begin.", 2),
        )

        val mainOptions = listOf(
            QueryMenuOption("Settings.", 3),
            QueryMenuOption("Exit match.", 4),
            QueryMenuOption("Cancel.", -1),
        )

        val allOptions = if (ui.match.isSetupPhase()) { setupOptions + mainOptions } else { mainOptions }

        UiStateHelper.openQueryMode(
            prompt = "What will you do?",
            options = allOptions,
            drawFn = { ui.draw() },
            enableCursorMovementKeys = true,
        ) { handleResponse(it) }
    }

    override fun handleEnter() {
    }

    override fun handleExit() {
    }

    override fun applyPanelHighlights() {
        if (!ui.match.isSetupPhase()) { return }
        TacticsMatchInstance.towerSummonPositions.map { toZonePanel(it) }.forEach { it.mask = ui.highlight(Highlight.aquaHighlight) }
    }

    override fun isBoardOnly(): Boolean {
        return false
    }

    private fun handleResponse(queryMenuOption: QueryMenuOption?): QueryMenuResponse {
        if (queryMenuOption == null || queryMenuOption.value <= 0) {
            ui.reset()
            return QueryMenuResponse.pop
        }

        if (queryMenuOption.value == 2) {
            return if (ui.match.getSummonedUnitCount() == 0) {
                ChatLog("Summon units first!", ChatLogColor.Error)
                QueryMenuResponse.noop(SystemSound.Invalid)
            } else {
                ui.match.completeSetupPhase()
                QueryMenuResponse.pop(SystemSound.FishSuccess)
            }
        }

        if (queryMenuOption.value == 3) {
            TacticsSettingSelectUi().push()
            return QueryMenuResponse.noop
        }

        if (queryMenuOption.value == 4) {
            UiStateHelper.pushYesNoMenu(
                text = "Really exit the match?",
                onYes = { ui.match.exit() },
                onNo = { UiStateHelper.popState(SystemSound.MenuClose) },
            )
        }

        return QueryMenuResponse.noop
    }

    private fun describeSelf() {
        if (described || TacticsState.hasClearedAnyItem()) { return }
        described = true
        ChatLog("${ShiftJis.solidSquare} Note: ${ShiftJis.colorWhite}Animation Speed${ShiftJis.colorClear} and ${ShiftJis.colorWhite}Enemy Turn Speed${ShiftJis.colorClear} can be modified in the ${ShiftJis.colorWhite}Settings${ShiftJis.colorClear} option at any time during a match.", ChatLogColor.SystemMessage)
    }

}

object TacticsSkillSelectHighlighter {

    fun applyPanelHighlights(ui: TacticsUi, subUi: TacticsSkillSelectUi, unit: ActorState) {
        val ability = subUi.getSelectedAbility() ?: return

        when (ability) {
            is PositionChoice -> applyPanelHighlights(ui, ability.positionSkill, unit)
            is SkillChoice -> applyPanelHighlights(ui, ability.skillId, unit)
            WaitChoice -> { }
        }
    }

    private fun applyPanelHighlights(ui: TacticsUi, ability: SkillId, unit: ActorState) {
        val (minRange, maxRange) = unit.getUnit().getSkillRange(ability)
        val info = TacticsSkills[ability]

        val destination = ui.match.getUnitPosition(unit)
        if (destination !is PanelPosition) { return }

        val attackPanels = ui.match.neighborsOf(destination, range = maxRange, allowDiagonal = info.aoeType != AoeType.Line)
            .filter { it.distance(destination) >= minRange }

        val targetFlags = ability.targetFlags()
        val allySkill = TargetFlag.Ally.match(targetFlags) || TargetFlag.Self.match(targetFlags)
        val highlight = if (allySkill) {
            Highlight.greenHighlight
        } else {
            Highlight.redHighlight
        }

        attackPanels.map { toZonePanel(it) }.forEach { it.mask = ui.highlight(highlight) }
    }

    private fun applyPanelHighlights(ui: TacticsUi, ability: TacticsPositionSkill, unit: ActorState) {
        val destination = ui.match.getUnitPosition(unit)
        if (destination !is PanelPosition) { return }

        val attackPanels = ui.match.neighborsOf(destination, range = 1).filter { it != destination }
        attackPanels.map { toZonePanel(it) }.forEach { it.mask = ui.highlight(Highlight.greenHighlight) }
    }

}